import { 
  signInWithEmailAndPassword, 
  signOut, 
  onAuthStateChanged,
  User,
  UserCredential
} from 'firebase/auth'
import { auth, shouldSkipFirestore } from './config'

// Login-Funktion
export const login = async (email: string, password: string): Promise<UserCredential> => {
  if (!auth) {
    throw new Error('Firebase Auth ist nicht initialisiert')
  }
  return await signInWithEmailAndPassword(auth, email, password)
}

// Logout-Funktion
export const logout = async (): Promise<void> => {
  if (!auth) {
    throw new Error('Firebase Auth ist nicht initialisiert')
  }
  return await signOut(auth)
}

// Auth State Observer
export const onAuthStateChange = (callback: (user: User | null) => void) => {
  // Wenn Bot/Performance-Tool oder Auth nicht initialisiert, überspringe den Observer
  if (shouldSkipFirestore || !auth) {
    callback(null)
    return () => {}
  }
  return onAuthStateChanged(auth, callback)
}

// Aktuellen User abrufen
export const getCurrentUser = (): User | null => {
  if (!auth) {
    return null
  }
  return auth.currentUser
}














